///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import {
    Component,
    ViewEncapsulation,
} from "@angular/core";

@Component({
    selector: "app-root",
    encapsulation: ViewEncapsulation.None,
    templateUrl: "./app.component.html",
    styleUrls: [
        "../../node_modules/@progress/kendo-theme-material/dist/all.css",
        "../../node_modules/bootstrap/dist/css/bootstrap.min.css",
        "../../node_modules/font-awesome/css/font-awesome.css",
        "./app.css",
        "./app.custom.css",
        "./kendo.overrides.css",
    ],
})
export class AppComponent {}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/app.component.ts